var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Accident from "./svg/Accident.svg";
import Animal from "./svg/Animal.svg";
import Boat from "./svg/Boat.svg";
import Cabin from "./svg/Cabin.svg";
import CabinContent from "./svg/CabinContents.svg";
import Car from "./svg/Car.svg";
import Caravan from "./svg/Caravan.svg";
import Child from "./svg/Child.svg";
import Death from "./svg/Death.svg";
import Disability from "./svg/Disability.svg";
import ElectricScooter from "./svg/ElectricScooter.svg";
import Health from "./svg/CriticalIllness.svg";
import House from "./svg/House.svg";
import HouseContents from "./svg/HouseContents.svg";
import { IconBase } from "./coopIconsStyled";
import { Icons } from "@storebrand-digital/insurance-definitions";
import Motorcycle from "./svg/Motorcycle.svg";
import Tractor from "./svg/Tractor.svg";
import Trailer from "./svg/Trailer.svg";
import Travel from "./svg/Travel.svg";
import Valuables from "./svg/Valuables.svg";
import Veteran from "./svg/Veteran.svg";
export const CoopIcon = (props) => {
    const { name } = props, rest = __rest(props, ["name"]);
    const renderCoopIcon = () => {
        switch (name) {
            case Icons.ACCIDENT:
                return React.createElement(Accident, null);
            case Icons.ANIMAL:
                return React.createElement(Animal, null);
            case Icons.BOAT:
                return React.createElement(Boat, null);
            case Icons.CABIN:
                return React.createElement(Cabin, null);
            case Icons.CABIN_CONTENT:
                return React.createElement(CabinContent, null);
            case Icons.CAR:
                return React.createElement(Car, null);
            case Icons.CARAVAN:
                return React.createElement(Caravan, null);
            case Icons.CHILD:
            case Icons.PREGNANT_AND_NEWBORN:
                return React.createElement(Child, null);
            case Icons.DEATH:
                return React.createElement(Death, null);
            case Icons.DISABILITY:
                return React.createElement(Disability, null);
            case Icons.ELECTRIC_SCOOTER:
                return React.createElement(ElectricScooter, null);
            case Icons.HEALTH:
            case Icons.ADVICE:
                return React.createElement(Health, null);
            case Icons.HOUSE:
                return React.createElement(House, null);
            case Icons.HOUSE_CONTENT:
                return React.createElement(HouseContents, null);
            case Icons.MOPED:
            case Icons.MOTORCYCLE:
                return React.createElement(Motorcycle, null);
            case Icons.TRACTOR:
                return React.createElement(Tractor, null);
            case Icons.TRAILER:
                return React.createElement(Trailer, null);
            case Icons.TRAVEL:
                return React.createElement(Travel, null);
            case Icons.VALUABLES:
                return React.createElement(Valuables, null);
            case Icons.VETERAN:
                return React.createElement(Veteran, null);
            default:
                return;
        }
    };
    return React.createElement(IconBase, Object.assign({}, rest), renderCoopIcon());
};
//# sourceMappingURL=CoopIcon.js.map